import * as types from '../../constants/ActionTypes';

export const setCustomer = data => ({
    type: types.SET_CUSTOMER,
    data,
});



// WEBPACK FOOTER //
// ./src/app/FormStepper/customerActions.js